import { render, staticRenderFns } from "./piechart.vue?vue&type=template&id=68c1e52b&scoped=true&"
import script from "./piechart.vue?vue&type=script&lang=js&"
export * from "./piechart.vue?vue&type=script&lang=js&"
import style0 from "./piechart.vue?vue&type=style&index=0&id=68c1e52b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c1e52b",
  null
  
)

export default component.exports